import React from 'react';
import { cn } from '@restworld/utils-common';

export const TitleAndButtonWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-center gap-3', className)} {...props} />
);

export default TitleAndButtonWrapper;
